import { useState } from "react";
import axiosInstance from "../../redux/helpers/axios";

const ACCENT_FROM = "#E11D74";
const ACCENT_TO = "#EF4444";
const inputClass =
  "mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2";

export default function CreateCampaignForm({ onCreated, onCancel }) {
  const [form, setForm] = useState({
    name: "",
    slug: "",
    image: "",
    description: "",
    startDate: "",
    endDate: "",
    slugTouched: false,
  });
  const [status, setStatus] = useState({ loading: false, error: null });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => {
      const next = { ...prev, [name]: value };
      if (name === "name" && !prev.slugTouched) {
        next.slug = value
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/(^-|-$)/g, "");
      }
      return next;
    });
  };

  const handleSlugChange = (e) => {
    setForm((prev) => ({ ...prev, slug: e.target.value, slugTouched: true }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, error: null });

    try {
      const res = await axiosInstance.post("/admin/campaign/create", {
        name: form.name,
        slug: form.slug,
        image: form.image,
        description: form.description,
        startDate: form.startDate || null,
        endDate: form.endDate || null,
      });
      onCreated(res.data.campaign);
    } catch (err) {
      setStatus({
        loading: false,
        error:
          err?.response?.data?.error ||
          err?.response?.data?.msg ||
          "Failed to create campaign",
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div>
        <label className="block text-sm font-medium text-gray-700">Name</label>
        <input
          type="text"
          name="name"
          required
          value={form.name}
          onChange={handleChange}
          placeholder="Eid Collection 2026"
          className={inputClass}
          style={{ "--tw-ring-color": ACCENT_FROM }}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">Slug</label>
        <input
          type="text"
          name="slug"
          required
          value={form.slug}
          onChange={handleSlugChange}
          placeholder="eid-collection-2026"
          className={`${inputClass} font-mono`}
          style={{ "--tw-ring-color": ACCENT_FROM }}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Image URL
        </label>
        <input
          type="text"
          name="image"
          value={form.image}
          onChange={handleChange}
          placeholder="https://..."
          className={inputClass}
          style={{ "--tw-ring-color": ACCENT_FROM }}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Description
        </label>
        <textarea
          name="description"
          rows={3}
          value={form.description}
          onChange={handleChange}
          className={inputClass}
          style={{ "--tw-ring-color": ACCENT_FROM }}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Start date
          </label>
          <input
            type="date"
            name="startDate"
            value={form.startDate}
            onChange={handleChange}
            className={inputClass}
            style={{ "--tw-ring-color": ACCENT_FROM }}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            End date
          </label>
          <input
            type="date"
            name="endDate"
            value={form.endDate}
            onChange={handleChange}
            className={inputClass}
            style={{ "--tw-ring-color": ACCENT_FROM }}
          />
        </div>
      </div>

      {status.error && (
        <p className="text-sm text-red-600" role="alert">
          {status.error}
        </p>
      )}

      <div className="flex gap-3 pt-2">
        <button
          type="button"
          onClick={onCancel}
          className="flex-1 rounded-md border border-gray-300 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={status.loading}
          className="flex-1 rounded-md py-2.5 text-sm font-medium text-white transition disabled:opacity-60"
          style={{
            background: `linear-gradient(90deg, ${ACCENT_FROM}, ${ACCENT_TO})`,
          }}
        >
          {status.loading ? "Creating..." : "Create campaign"}
        </button>
      </div>
    </form>
  );
}
